import React from 'react';
import Banner from '../Banner/Banner';
import Services from '../Services/Services';


const Home = () => {
    return (
        <>
            <Banner></Banner>
            <Services></Services>
        </>
    );
};

export default Home;